import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import LightIcon from '@material-ui/icons/WbSunny';
import DarkIcon from '@material-ui/icons/Brightness2';
import { UnifiedThemeProvider } from '@backstage/theme';
import { themeLight, themeDark } from '.';

const lightThemeExtension = ThemeBlueprint.make({
  name: 'light',
  params: {
    theme: {
      id: 'light',
      title: 'Light',
      variant: 'light',
      icon: <LightIcon />,
      Provider: ({ children }) => <UnifiedThemeProvider theme={themeLight} children={children} />,
    },
  },
});

const darkThemeExtension = ThemeBlueprint.make({
  name: 'dark',
  params: {
    theme: {
      id: 'dark',
      title: 'Dark',
      variant: 'dark',
      icon: <DarkIcon />,
      Provider: ({ children }) => <UnifiedThemeProvider theme={themeDark} children={children} />,
    },
  },
});

export const themesModule = createFrontendModule({
  pluginId: 'app',
  extensions: [lightThemeExtension, darkThemeExtension],
});
